import { render, staticRenderFns } from "./collection-add.vue?vue&type=template&id=096eb100&scoped=true&"
import script from "./collection-add.vue?vue&type=script&lang=js&"
export * from "./collection-add.vue?vue&type=script&lang=js&"
import style0 from "./collection-add.vue?vue&type=style&index=0&id=096eb100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096eb100",
  null
  
)

export default component.exports